import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, message, Typography, Card, Row, Col, Divider } from 'antd';
import { 
  UserOutlined, 
  LockOutlined, 
  LoginOutlined,
  SafetyOutlined 
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './index.css';
import { loginStart, loginSuccess, loginFailure } from '../../redux/userSlice';
import auth from '../../services/auth';

const { Title, Text, Paragraph } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    dispatch(loginStart());

    try {
      const response = await auth.login(values);
      console.log(response);
      setLoading(false);
      if (response.data.is_locked == "1") {
        message.error('Your account is locked. Please contact support.');
        dispatch(loginFailure());
        return;
      }
      const token = response.data.token;
      localStorage.setItem('token', token);
      const previousUrl = location?.state?.prevUrl;
      const dashboardUrl = '/dashboard';
      navigate(previousUrl ? previousUrl : dashboardUrl);
      dispatch(loginSuccess(response.data));
      message.success('Login successful');
    } catch (error) {
      if (error.response && error.response.status === 422) {
        message.error('Invalid credentials. Please check your username and password.');
      } else {
        message.error('Login failed. Please try again later.');
      }
      setLoading(false);
      dispatch(loginFailure());
    }
  };

  return (
    <div className="login-page">
     

      <div className="login-content">
        <Row justify="center" align="middle" className="login-row">
          <Col xs={24} sm={20} md={12} lg={8}>
            <Card className="login-card">
              <div className="login-card-header">
                <Title level={2}>Welcome Back</Title>
                <Text type="secondary">
                  Sign in to access your account
                </Text>
              </div>

              <Form
                name="login_form"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                size="large"
              >
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email', message: 'Please enter a valid email!' }
                  ]}
                >
                  <Input
                    prefix={<UserOutlined className="input-icon" />}
                    placeholder="Email Address"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: 'Please input your password!' }
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="input-icon" />}
                    placeholder="Password"
                  />
                </Form.Item>

                <div className="login-options">
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                  {/* <Button type="link" className="forgot-password">
                    Forgot password?
                  </Button> */}
                </div>

                <Form.Item>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    className="login-button"
                    loading={loading}
                    icon={<LoginOutlined />}
                    block
                    style={{ color: '#fff !important' }}
                  >
                    Sign In
                  </Button>
                </Form.Item>
              </Form>

              <Divider plain>
                <Text type="secondary">Secure Login</Text>
              </Divider>

              <div className="login-footer">
                <SafetyOutlined className="security-icon" />
                <Paragraph type="secondary" className="security-text">
                  Your connection to this site is secure and your information is protected.
                </Paragraph>
                <div style={{ textAlign: 'center', marginTop: '16px' }}>
                  <Text type="secondary" style={{ fontSize: '12px' }}>
                    By signing in, you agree to our{' '}
                    <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                      Terms
                    </a>
                    {' '}and{' '}
                    <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                      Terms of Service
                    </a>
                  </Text>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      
    </div>
  );
};

export default Login;
